import { render, staticRenderFns } from "./prudential-white-label.vue?vue&type=template&id=2a16a6e2&scoped=true&lang=pug&"
import script from "./prudential-white-label.vue?vue&type=script&lang=js&"
export * from "./prudential-white-label.vue?vue&type=script&lang=js&"
import style0 from "./prudential-white-label.vue?vue&type=style&index=0&id=2a16a6e2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16a6e2",
  null
  
)

export default component.exports